module.exports = __webpack_public_path__ + "img/paternkofel.0b705907.jpg";